<div class="library-container">

  <div class="content">

    <div class="carousel-container">
      @if(carouselStore.isLoading() || isResized) {
        <mat-spinner></mat-spinner>
      } @else {
        @if(carouselStore.items().length > 1) {
          <div class="d-flex align-center justify-around w-100">

            <div class="carousel-wrapper">
              <owl-carousel-o [options]="customOptions" >
                @for (slide of carouselStore.items(); track slide.id) {
                  <ng-template carouselSlide>
                    <img [src]="slide.image" height="380" style="width: calc(100%); display: block;" (click)="slideClicked(slide)" class="pointer" alt="slide">
                  </ng-template>
                }

              </owl-carousel-o>
            </div>
          </div>

        }
      }
    </div>
    <div style="margin: 32px;">


      <app-tracks-list
        [dataSource]="dataSource"
        [tracksTotal]="tracksTotal"
        [isLoading]="store.isLoading()"
        [pageIndex]="index"
        (pageChanged)="changePage($event)"
        (sortChanged)="sortChange($event)"
        (downloadClicked)="download($event)"
      >

      </app-tracks-list>
    </div>


  </div>
  <div class="sidebar">
    <div class="pb-48">
      <app-icon-input [formControl]="searchValue" placeholder="Search by title or artist"></app-icon-input>
    </div>

    <h4>Filter</h4>
    <div class="pb-12">
      <div class="user-dropdown-filter">
        <input type="text"
               placeholder="Category"
               aria-label="Category"
               matInput
               #categoriesInput="matAutocompleteTrigger"
               [(ngModel)]="category"
               [matAutocomplete]="categoriesEl">
        <mat-autocomplete #categoriesEl="matAutocomplete" [displayWith]="displayFn">
          @for (option of store.categories(); track option) {
            <mat-option [value]="option">{{option.name}}</mat-option>
          }
        </mat-autocomplete>
        @if(category()) {
          <mat-icon class="clear-field-icon" (click)="category.set(null)">cancel</mat-icon>
        }
        <mat-icon class="open-trigger-icon" (click)="openPanel(categoriesInput)">arrow_drop_down</mat-icon>

      </div>
    </div>
    <div class="pb-12">
      <div class="user-dropdown-filter">
        <input type="text"
               placeholder="Genre"
               aria-label="Genre"
               matInput
               #genresInput="matAutocompleteTrigger"
               [(ngModel)]="genre"
               [matAutocomplete]="genresEl">
        <mat-autocomplete #genresEl="matAutocomplete" [displayWith]="displayFn">
          @for (option of store.genres(); track option) {
            <mat-option [value]="option">{{option.name}}</mat-option>
          }
        </mat-autocomplete>
        @if(genre()) {
          <mat-icon class="clear-field-icon" (click)="genre.set(null)">cancel</mat-icon>
        }
        <mat-icon class="open-trigger-icon" (click)="openPanel(genresInput)">arrow_drop_down</mat-icon>

      </div>
    </div>

    <div class="pb-48">
      <div class="user-dropdown-filter">
        <input type="text"
               placeholder="Sub-Genre"
               aria-label="Sub Genre"
               matInput
               #subGenresInput="matAutocompleteTrigger"
               [(ngModel)]="subGenre"
               [matAutocomplete]="subGenresEl">
        <mat-autocomplete #subGenresEl="matAutocomplete" [displayWith]="displayFn">
          @for (option of store.subgenres(); track option) {
            <mat-option [value]="option">{{option.name}}</mat-option>
          }
        </mat-autocomplete>
        @if(subGenre()) {
          <mat-icon class="clear-field-icon" (click)="subGenre.set(null)">cancel</mat-icon>
        }

        <mat-icon class="open-trigger-icon" (click)="openPanel(subGenresInput)">arrow_drop_down</mat-icon>
      </div>
    </div>



    <h4 class="pb-24">Top 20</h4>

    <app-top-tracks></app-top-tracks>

  </div>

</div>
